module.exports = __webpack_public_path__ + "img/icon_dot_red.140b611a.svg";